<template>
  <el-dialog
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_SettlementNotice')"
    width="740px"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    top="5vh"
    custom-class="details-view settlement-notice"
  >
    <div class="main-content">
      <div style="margin-bottom: 10px">
        <div style="width: 100%">
          <div class="form-row">
            <el-form
              label-position="left"
              :inline="true"
              label-width="75px"
            >
              <el-form-item :label="$t('CargoMsg.Cargo_BranchCMP')">
                <el-select v-model="filter.officeId" style="width: 200px" :allow-create="true" no="1">
                  <el-option
                    v-for="(item,index) in officeAmounts"
                    :key="index"
                    :label="item.officeChineseName"
                    :value="item.officeId"
                  />
                </el-select>
              </el-form-item>
              <el-checkbox v-model="filter.se" :label="$t('CargoMsg.Cargo_OceanFreight')" no="2" />
              <el-checkbox v-model="filter.ae" :label="$t('CargoMsg.Cargo_Air')" no="3" />
            </el-form>
          </div>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015206"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
          @gridReady="onGridReady"
        />
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" no="4" @click="preViewClickHandler">{{
        $t('CargoMsg.Cargo_PreviewEmailContent')
      }}</el-button>
      <el-button type="primary" no="5" @click="sendOfficeClickHandler">{{
        $t('CargoMsg.Cargo_SendToBranchCompany')
      }}</el-button>
      <el-button no="6" @click="onCancel">{{
        $t('CargoMsg.Cargo_Cancel')
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import CargoAgGrid from '@/components/Cargo/Common/cargoAgGrid'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import StrUtils from '@/utils/StrUtils'
import { preViewOfficeHtml, sendOfficeConfirm } from '@/api/clearing/actualAmount'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'

export default {
  name: 'BillNoticeResultWindow',
  components: { CargoAgGrid, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    selectItems: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      filter: {
        officeId: null,
        se: true,
        ae: true
      },
      officeAmounts: [], // 相同分公司数据
      officeGridDatas: [], // 分公司详细数据
      rowData: [],
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        frameworkComponents: {
          CargoAgGridCommonInputEditor
        },
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffAmount'), field: 'amount', colId: 'amount', width: 200,
          valueFormatter: (params) => {
            if (this.filter.se && this.filter.ae) {
              return params.value ? ClearingUtils.numberPrecision(params.value) : 0
            } else if (this.filter.se) {
              return params.data.seAmount ? ClearingUtils.numberPrecision(params.data.seAmount) : 0
            } else if (this.filter.ae) {
              return params.data.aeAmount ? ClearingUtils.numberPrecision(params.data.aeAmount) : 0
            } else {
              return 0
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AmountOfActualCollectionPayment'),
          field: 'paymentAmount',
          colId: 'paymentAmount',
          width: 100,
          valueFormatter: (params) => {
            return params.value ? ClearingUtils.numberPrecision(params.value) : 0
          }
        }, {
          headerName: this.$t('WriteOff.exchangeGainsAndLosses'),
          field: 'diffChange',
          colId: 'diffChange',
          width: 100,
          valueFormatter: (params) => {
            return params.value ? ClearingUtils.numberPrecision(params.value) : 0
          }
        }, {
          headerName: this.$t('WriteOff.financialCharges'),
          field: 'financialCost',
          colId: 'financialCost',
          width: 100,
          valueFormatter: (params) => {
            return params.value ? ClearingUtils.numberPrecision(params.value) : 0
          }
        }, {
          headerName: this.$t('WriteOff.oddment'),
          field: 'clearOdd',
          colId: 'clearOdd',
          width: 100,
          valueFormatter: (params) => {
            return params.value ? ClearingUtils.numberPrecision(params.value) : 0
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_RemittanceFee'),
          colId: 'remittanceFee',
          field: 'remittanceFee',
          initialWidth: 200,
          valueFormatter: (params) => {
            if (StrUtils.isEmpty(params.value)) return '0.00'
            return params.value
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ExchangeRateDifference'),
          colId: 'exchangeDiff',
          field: 'exchangeDiff',
          initialWidth: 200,
          valueFormatter: (params) => {
            if (StrUtils.isEmpty(params.value)) return '0.00'
            return params.value
          },
          editable: true,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          }
        }
      ]
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        } else {
          this.$emit('open', val)
        }
      }
    }
  },
  watch: {
    filter: {
      handler: function() {
        this.$nextTick(() => {
          this.gridOptions.api.refreshCells({ force: true })
        })
      },
      deep: true
    }
  },
  mounted() {
    this.getGroupByOfficeAmount()
    this.initOfficeGridData()
    this.initSelectOffice()
  },
  methods: {
    onGridReady(p) {
      this.gridApi = p.api
      this.gridApi.selectAll()
    },
    // 按分公司进行分组
    getGroupByOfficeAmount() {
      if (this.officeAmounts === null) {
        this.officeAmounts = []
      }
      for (const act of this.selectItems) {
        for (const clear of act.clearHistory) {
          if (clear.confirmState === 0) {
            if (!this.branchExist(clear.branchId, this.officeAmounts)) {
              const officeItem = {}
              const arr = [] // 核销明细
              arr.push(clear)
              officeItem.officeId = clear.branchId
              officeItem.officeChineseName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', clear.branchId, 'chineseName')
              officeItem.actualAmounts = arr
              this.officeAmounts.push(officeItem)
            } else {
              for (const item of this.officeAmounts) {
                if (item.officeId === clear.branchId) {
                  const actualAmounts = item.actualAmounts
                  actualAmounts.push(clear)
                }
              }
            }
          }
        }
      }
    },
    // 初始化所有分公司表格数据
    initOfficeGridData() {
      this.officeGridDatas = []
      const officeAmounts = this.officeAmounts
      for (const item of officeAmounts) {
        const o = {}
        o.officeId = item.officeId
        o.dataProvider = this.getOfficeClearHistory(item.actualAmounts)
        this.officeGridDatas.push(o)
      }
    },
    // 加载一个分公司数据
    initSelectOffice() {
      if (this.officeAmounts && this.officeAmounts.length > 0) {
        this.filter.officeId = this.officeAmounts[0].officeId
        this.getSelectItemOfficeGridData()
      }
    },
    getSelectItemOfficeGridData() {
      this.filter.se = true
      this.filter.ae = true
      this.rowData = this.getCurrentOfficeDataProvider()
    },
    getCurrentOfficeDataProvider() {
      for (const item of this.officeGridDatas) {
        if (item.officeId === this.filter.officeId) {
          return item.dataProvider
        }
      }
      return null
    },
    // 相同分公司按照结算对象进行汇总
    getOfficeClearHistory(actualAmounts) {
      const gridData = []
      for (const clear of actualAmounts) {
        const lob = this.getLob(clear.lob)
        if (!this.accountIdExist(clear, gridData, lob)) {
          const gridItem = {}
          gridItem.branchId = clear.branchId
          gridItem.accountId = clear.accountId
          gridItem.clearKey = clear.uuid
          gridItem.ar = clear.ar
          const clearAmount = clear.ar ? clear.actualAmt : -clear.actualAmt
          gridItem.amount = Number(clearAmount.toFixed(2))
          gridItem.diffClearInfo = this.createDiffLobClearInfo(gridItem, lob)
          gridItem.remittanceFee = ''
          gridItem.exchangeDiff = ''
          gridItem.currency = clear.actualCurrency

          // CARGO-29427 CLONE - 海外结算中心，在通知分公司时，未显示财务费用
          const paymentAmount = clear.ar ? clear.paymentAmount : -clear.paymentAmount
          gridItem.paymentAmount = Number(paymentAmount.toFixed(2))
          const diffChange = clear.ar ? clear.diffChange : -clear.diffChange
          gridItem.diffChange = Number(diffChange.toFixed(2))
          const financialCost = clear.ar ? clear.financialCost : -clear.financialCost
          gridItem.financialCost = Number(financialCost.toFixed(2))
          const clearOdd = clear.ar ? clear.clearOdd : -clear.clearOdd
          gridItem.clearOdd = Number(clearOdd.toFixed(2))

          gridData.push(gridItem)
        }
      }
      // 重新遍历列表，将海运金额和空运金额塞入
      for (const item of gridData) {
        let seAmount = 0
        let aeAmount = 0
        for (const item of item.diffClearInfo) {
          if (item.lob === 'SE') {
            seAmount = seAmount + item.amount
          }
          if (item.lob === 'AE') {
            aeAmount = aeAmount + item.amount
          }
        }
        const aeClearAmount = item.ar ? aeAmount : -aeAmount
        item.aeAmount = Number(aeClearAmount.toFixed(2))
        const seClearAmount = item.ar ? seAmount : -seAmount
        item.seAmount = Number(seClearAmount.toFixed(2))
      }
      return gridData
    },
    // 默认初始化海空运汇总数据
    createDiffLobClearInfo(sourceItem, lob) {
      const diffs = []
      const itemSE = {}
      itemSE.lob = 'SE'
      itemSE.amount = this.getLob(lob) === 'SE' ? sourceItem.amount : 0
      itemSE.clearKey = this.getLob(lob) === 'SE' ? sourceItem.clearKey : ''
      const itemAE = {}
      itemAE.lob = 'AE'
      itemAE.amount = this.getLob(lob) === 'AE' ? sourceItem.amount : 0
      itemAE.clearKey = this.getLob(lob) === 'AE' ? sourceItem.clearKey : ''

      diffs.push(itemAE)
      diffs.push(itemSE)

      return diffs
    },
    getLob(lob) {
      if (lob === 'SE' || lob === 'SI') { return 'SE' }
      if (lob === 'AE' || lob === 'AI') { return 'AE' }
      return ''
    },
    // 同一个结算对象,进行金额汇总(分海空运)
    accountIdExist(clear, gridData, lob) {
      for (const item of gridData) {
        if (item.accountId === clear.accountId) {
          const clearAmount = clear.ar ? clear.actualAmt : -clear.actualAmt
          const oldAmount = clearAmount
          item.amount += oldAmount

          item.ar = clear.ar
          // CARGO-29427 CLONE - 海外结算中心，在通知分公司时，未显示财务费用
          const paymentAmount = clear.ar ? clear.paymentAmount : -clear.paymentAmount
          item.paymentAmount += paymentAmount
          const diffChange = clear.ar ? clear.diffChange : -clear.diffChange
          item.diffChange += diffChange
          const financialCost = clear.ar ? clear.financialCost : -clear.financialCost
          item.financialCost += financialCost
          const clearOdd = clear.ar ? clear.clearOdd : -clear.clearOdd
          item.clearOdd += clearOdd

          if (item.clearKey.length === 0) {
            item.clearKey = clear.uuid
          } else {
            item.clearKey += ',' + clear.uuid
          }
          this.getDiffLobClearInfo(item, lob, oldAmount, clear.uuid)
          return true
        }
      }
      return false
    },
    // 汇总海空运金额和核销uuids
    getDiffLobClearInfo(item, lob, amount, clearKey) {
      const diffs = item.diffClearInfo
      for (const o of diffs) {
        if (o.lob === lob) {
          o.amount += amount
          if (o.clearKey.length === 0) {
            o.clearKey = clearKey
          } else {
            o.clearKey += ',' + clearKey
          }
        }
      }
    },
    branchExist(branchId, offices) {
      for (const item of offices) {
        if (item.officeId === branchId) { return true }
      }
      return false
    },
    preViewClickHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataToPreview'))
        return
      }
      preViewOfficeHtml(selectedRows).then(res => {
        const key = res.data
        if (StrUtils.isEmpty(key)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ContentIsEmpty'))
          return
        }
        window.open(`${URL.act.actualAmount.preViewOfficeHtmlPage}?sessionId=${getToken()}&key=${key}`)
      })
    },
    sendOfficeClickHandler() {
      const selectedRows = this.gridOptions.api.getSelectedRows()
      if (!selectedRows || selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoDataToTransfer'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToDeliverToBranch'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        this.fullscreenLoading = getLoading()
        sendOfficeConfirm(selectedRows, { officeId: this.filter.officeId }).then(res => {
          this.fullscreenLoading.close()
          if (res.data === 'ok') {
            this.$message.success(this.$t('CargoMsg.Cargo_EmailSent'))
            this.$emit('refresh')
            this.onCancel()
          } else if (res.data === 'fail') {
            this.$message.warning(this.$t('CargoMsg.Cargo_SendFailed'))
          } else {
            this.$message.warning(res.data)
          }
        }).catch(() => {
          this.fullscreenLoading.close()
        })
      })
    },
    onCancel() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  @import "~@/styles/element-variables.scss";
  .settlement-notice{
    .el-checkbox{
      margin-top: 6px;
    }
    .el-textarea__inner{
      min-height: 100px !important;
    }
    .form-operator{
      margin-left: 5px;
      cursor: pointer;
      font-size: 18px;
      .el-icon-circle-plus{
        color: $--color-success;
      }
      .el-icon-remove
      {
        color: $--color-danger;
      }
    }
  }
</style>
